import minimatch from 'minimatch';
export var urlIsWhitelisted = function (url) {
    var _a;
    if (!process.env.REACT_APP_HOSTNAME_WHITELIST) {
        console.error('process.env.REACT_APP_HOSTNAME_WHITELIST not set');
        return false;
    }
    var whitelist = ((_a = process.env.REACT_APP_HOSTNAME_WHITELIST) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
    var isWhitelisted = whitelist.some(function (pattern) {
        return minimatch(url, pattern);
    });
    console.log(url, isWhitelisted ? '' : 'not', 'whitelisted');
    return isWhitelisted;
};
